import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import useAuthentication from 'hooks/use-authentication';
const { getUserNameFromToken } = useAuthentication();
const FinishPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    setTimeout(() => {
        localStorage.clear();
        navigate('/login', { replace: true });
    }, 10000);
    return (_jsx("div", Object.assign({ className: "modal--inline modal--success", style: { boxShadow: '0px 0px 0 0 rgb(0 0 0 / 10%)' } }, { children: _jsxs("div", Object.assign({ className: "modal-body" }, { children: [_jsxs("header", { children: [_jsx("span", { children: t('FINISH.GREAT_JOB').replace('USERNAME', getUserNameFromToken() || '') }, void 0), _jsx("h1", { children: t('FINISH.CONGRATS') }, void 0)] }, void 0), _jsx("p", { children: t('FINISH.EXAM_SENT') }, void 0)] }), void 0) }), void 0));
};
export default FinishPage;
